module.exports = __webpack_public_path__ + "static/media/aragon.89dcc35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/hackathon/aragon.png
// module id = 435
// module chunks = 0